<template>
  <!-- 用户账户 -->
  <div id="app">
    <div class="center-tit">我的账户<span>/My Account</span></div>
    <div class="account-con">
      <div class="account-list">
        <div class="list-le">
          <img src="@/assets/center/account-icon1.png" />
          <h2 v-if="userInfo.email">
            邮箱{{
              `${userInfo.email.split("@")[0].substr(0, 3)}****${
                userInfo.email.split("@")[1]
              }`
            }}已绑定
          </h2>
          <h2 v-else>邮箱未绑定</h2>
          <p>可用邮箱加密码登录本网站，可用邮箱找回密码</p>
        </div>
        <div class="list-rg" v-if="userInfo.email">
          <p class="renzheng">
            <img src="@/assets/center/renzheng-icon.png" />已绑定
          </p>
        </div>
        <div class="list-rg" v-else>
          <p class="btn" @click="cerVisible2 = true">添加绑定</p>
        </div>
      </div>
      <div class="account-list">
        <div class="list-le">
          <img src="@/assets/center/account-icon3.png" style="width: 20px" />
          <h2 v-if="userInfo.phone">
            手机号+{{ userInfo.phone.substr(0, 3) + "********" }}已绑定
          </h2>
          <h2 v-else>手机号未绑定</h2>
          <p>可用手机加密码/验证码登录本网站</p>
        </div>
        <div class="list-rg" v-if="userInfo.phone">
          <p class="renzheng">
            <img src="@/assets/center/renzheng-icon.png" />已绑定
          </p>
        </div>
        <div class="list-rg" v-else>
          <p class="btn" @click="cerVisible = true">添加绑定</p>
        </div>
      </div>

      <div
        class="account-list"
        v-if="
          (userInfo.email && userInfo.email != '') ||
          (userInfo.phone && userInfo.phone != '')
        "
      >
        <div class="list-le">
          <img src="@/assets/center/account-icon2.png" style="width: 25px" />
          <h2>密码已设置</h2>
          <p>用于保护账号信息和登录安全</p>
        </div>
        <div class="list-rg">
          <p class="btn" @click="setpassword">更改</p>
        </div>
      </div>
      <div class="account-list">
        <div class="list-le">
          <img src="@/assets/center/wechat.png" style="width: 30px" />
          <h2>微信账号绑定</h2>
          <p>绑定微信账号后，可用微信登录</p>
        </div>
        <div class="list-rg">
          <p
            v-if="!this.$store.state.userInfo.openIdStatus"
            class="btn"
            @click="opening"
          >
            添加绑定
          </p>
          <p v-else class="renzheng">
            <img src="@/assets/center/renzheng-icon.png" />已绑定
          </p>
        </div>
      </div>
    </div>
    <!--    <div class="center-tit account-tab">-->
    <!--      <ul>-->
    <!--        <li :class="idx == index?'active':''" :key="index" @click="tabNav(index)" v-for="(item,index) in tabList">{{item.name}}</li>-->
    <!--      </ul>-->
    <!--    </div>-->
    <!--    <div class="account-coupon clearfix">-->
    <!--      <div class="coupon-bg">-->
    <!--        <h2><span>¥</span>50</h2>-->
    <!--        <p>有效期截止至：2020.02.22单次购买任意一门小课使用</p>-->
    <!--      </div>-->
    <!--      <div class="coupon-bg">-->
    <!--        <h2><span>¥</span>50</h2>-->
    <!--        <p>有效期截止至：2020.02.22单次购买任意一门小课使用</p>-->
    <!--      </div>-->
    <!--      <div class="coupon-bg">-->
    <!--        <h2><span>¥</span>50</h2>-->
    <!--        <p>有效期截止至：2020.02.22单次购买任意一门小课使用</p>-->
    <!--      </div>-->
    <!--    </div>-->
    <div
      class="mask"
      v-show="bindingWechat"
      @click="
        bindingWechat = false;
        msg = '';
      "
    ></div>
    <el-dialog :visible.sync="bindingWechat" append-to-body width="360px">
      <div style="text-align: center">
        <span style="font-size: 18px">绑定微信</span>
        <br />
        <img
          :src="qrcode"
          style="width: 140px; height: 140px; vertical-align: top"
        />
      </div>
    </el-dialog>

    <!-- 绑定弹窗   6.17 -->
    <div v-if="cerVisible" class="submit-con">
      <div class="ali-box" style="padding: 25px 120px">
        <img
          class="close"
          src="@/assets/img/cartdelete-icon.png"
          @click="cerVisible = false"
        />
        <div class="confirm-con">
          <div class="cer-title">手机号绑定</div>
          <el-form class="cer-form" ref="form" :model="cerPhoneform">
            <div class="cer-flex">
              <el-select
                class="cer-select"
                v-model="countrysvalue"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in countrys"
                  :key="item.val"
                  :label="item.label"
                  :value="item.val"
                >
                  <div class="select-row">
                    <span class="label">{{ item.label }}</span>
                    <span class="value">{{ item.value }}</span>
                  </div>
                </el-option>
              </el-select>
              <div class="flex-bd">
                <el-input v-model="cerPhoneform.phone"></el-input>
              </div>
            </div>
            <div class="cer-flex">
              <div class="flex-bd">
                <el-input v-model="cerPhoneform.code"></el-input>
              </div>
              <el-button v-show="show" @click="getCode" class="btn-code"
                >发送验证码</el-button
              >
              <el-button v-show="!show" class="btn-code btn-diable"
                >发送验证码</el-button
              >
              <div v-show="!show" class="tip-span">{{ count }} s</div>
            </div>
            <div class="cer-flex" v-if="!passwordExist">
              <el-input
                v-model="cerPhoneform.password"
                placeholder="请输入新密码"
                type="password"
              ></el-input>
            </div>
            <div style="text-align: center">
              <button class="next" @click="bandPhone">确 定</button>
              <button class="cancel" @click="cerVisible = false">取消</button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 绑定弹窗   6.17 -->
    <div v-if="cerVisible2" class="submit-con">
      <div class="ali-box" style="padding: 25px 120px">
        <img
          class="close"
          src="@/assets/img/cartdelete-icon.png"
          @click="cerVisible2 = false"
        />
        <div class="confirm-con">
          <div class="cer-title">邮箱绑定</div>
          <el-form class="cer-form" ref="form" :model="cerEmailform">
            <div class="cer-flex">
              <el-input
                v-model="cerEmailform.email"
                placeholder="请输入邮箱"
              ></el-input>
            </div>
            <div class="cer-flex">
              <div class="flex-bd">
                <el-input v-model="cerEmailform.code"></el-input>
              </div>
              <el-button v-show="show2" @click="getCode2" class="btn-code"
                >发送验证码</el-button
              >
              <el-button v-show="!show2" class="btn-code btn-diable"
                >发送验证码</el-button
              >
              <div v-show="!show2" class="tip-span">{{ count2 }} s</div>
            </div>
            <div class="cer-flex" v-if="!passwordExist">
              <el-input
                v-model="cerEmailform.password"
                placeholder="请输入新密码"
                type="password"
              ></el-input>
            </div>
            <div style="text-align: center">
              <button class="next" @click="bandEmail">确 定</button>
              <button class="cancel" @click="cerVisible2 = false">取消</button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  wechatBind,
  sendVerificationCode,
  bandEmailOrPhone,
  getPasswordExist,
} from "@/service/index.js";

export default {
  name: "account",
  data() {
    return {
      idx: 0,
      stateIndex: 0,
      bindingWechat: false,
      qrcode: "",
      cerVisible: false,
      cerVisible2: false,
      cerPhoneform: {
        phone: "",
        code: "",
        password: "",
      },
      cerEmailform: {
        email: "",
        code: "",
        password: "",
      },
      show: true,
      count: "",
      timer: null,
      show2: true,
      count2: "",
      timer2: null,
      countrys: [
        {
          value: "美国 & 加拿大",
          label: "+1",
          val: "1",
        },
        {
          value: "中国",
          label: "+86",
          val: "86",
        },
        {
          value: "台湾",
          label: "+886",
          val: "886",
        },
        {
          value: "香港",
          label: "+852",
          val: "852",
        },
        {
          value: "澳大利亚",
          label: "+61",
          val: "61",
        },
        {
          value: "英国",
          label: "+44",
          val: "44",
        },
        {
          value: "德国",
          label: "+49",
          val: "49",
        },
        {
          value: "爱尔兰",
          label: "+353",
          val: "353",
        },
        {
          value: "瑞士",
          label: "+41",
          val: "41",
        },
        {
          value: "荷兰",
          label: "+31",
          val: "31",
        },
        {
          value: "法国",
          label: "+33",
          val: "33",
        },
        {
          value: "西班牙",
          label: "+34",
          val: "34",
        },
        {
          value: "新西兰",
          label: "+64",
          val: "64",
        },
        {
          value: "俄罗斯",
          label: "+7",
          val: "7",
        },
        {
          value: "韩国",
          label: "+82",
          val: "82",
        },
        {
          value: "日本",
          label: "+81",
          val: "81",
        },
        {
          value: "阿拉伯联合酋长国",
          label: "+971",
          val: "971",
        },
      ],
      countrysvalue: "1",
      passwordExist: false,
    };
  },
  computed: mapState(["userInfo"]),
  watch: {},
  created() {},
  mounted() {
    this.getBindingWechatQrCode();
    this.getPasswordExist();
  },
  methods: {
    tabNav(index) {
      this.tabList.forEach((element, i) => {
        if (i == index) {
          element.checked = true;
        } else {
          element.checked = false;
        }
      });

      this.idx = index;
    },
    setpassword() {
      this.$router.push("/findpassword");
    },
    opening() {
      this.bindingWechat = true;
    },
    getBindingWechatQrCode() {
      wechatBind().then((res) => {
        console.log(res.result);
        if (res.result) this.qrcode = res.result.img;
      });
    },
    postScore() {},
    bandEmailOrPhone(phoneOrEmail, code, password) {
      bandEmailOrPhone(phoneOrEmail, code, password).then((res) => {
        if (res.success) {
          this.$message.success("绑定成功");
          this.cerVisible = false;
          this.cerVisible2 = false;
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    bandEmail() {
      if (!this.passwordExist) {
        if (!this.checkPasswordInput(this.cerEmailform.password)) {
          return this.$message.error("请设置6~16位数字与字母组合的密码！");
        }
      }
      this.bandEmailOrPhone(
        this.cerEmailform.email,
        this.cerEmailform.code,
        this.cerEmailform.password
      );
    },
    checkPasswordInput(password) {
      if (
        password.length == 0 ||
        password.length < 6 ||
        password.length > 16 ||
        /^\d{1,}$/.test(password) ||
        /^[a-zA-Z]*$/.test(password)
      ) {
        return false;
      }
      return true;
    },
    bandPhone() {
      if (!this.passwordExist) {
        if (!this.checkPasswordInput(this.cerPhoneform.password)) {
          return this.$message.error("请设置6~16位数字与字母组合的密码！");
        }
      }
      this.bandEmailOrPhone(
        this.countrysvalue + this.cerPhoneform.phone,
        this.cerPhoneform.code,
        this.cerPhoneform.password
      );
    },
    // 6.17
    getCode() {
      sendVerificationCode(this.countrysvalue + this.cerPhoneform.phone).then(
        (res) => {
          if (res.success) {
            this.$message.success("发送成功");
          }
        }
      );

      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },

    getCode2() {
      sendVerificationCode(this.cerEmailform.email).then((res) => {
        if (res.success) {
          this.$message.success("发送成功");
        }
      });

      const TIME_COUNT = 60;
      if (!this.timer2) {
        this.count2 = TIME_COUNT;
        this.show2 = false;
        this.timer2 = setInterval(() => {
          if (this.count2 > 0 && this.count2 <= TIME_COUNT) {
            this.count2--;
          } else {
            this.show2 = true;
            clearInterval(this.timer2);
            this.timer2 = null;
          }
        }, 1000);
      }
    },
    getPasswordExist() {
      getPasswordExist().then((res) => {
        if (res.success) {
          this.passwordExist = res.result;
        }
      });
    },
  },
};
</script>

<style scoped>
.mask {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* 6.17 */
.cert-dialog {
  position: fixed;
  width: 590px;
  box-sizing: border-box;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.cer-flex {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.flex-bd {
  flex: 1;
}
.cer-title {
  padding: 15px 0;
  text-align: center;
  font-size: 16px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #34495e;
}
.cer-form {
  padding: 15px 0;
}
.cer-form .btn-code {
  width: 100px;
  height: 32px;
  padding: 0;
  text-align: center;
  border: 0;
  margin-left: 15px;
  color: #34495e;
  background: rgba(136, 148, 171, 0.2);
  border-radius: 2px;
}
.cer-form .btn-diable {
  opacity: 0.5;
  cursor: auto;
}
.tip-span {
  font-size: 14px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.5);
  line-height: 14px;
  margin-left: 15px;
}

.select-row {
  display: block;
}
.select-row .label {
  display: inline-block;
  width: 60px;
}

.ali-box .next {
  width: 88px;
}
.ali-box .cancel {
  width: 88px;
  height: 32px;
  background: linear-gradient(to left, #34495e, #9da6b0);
  background: -moz-linear-gradient(to left, #34495e, #9da6b0);
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: 3px;
  margin-left: 30px;
}
::v-deep .el-dialog__body {
  padding: 50px 30px;
  padding-top: 20px;
}
::v-deep .el-dialog {
  border-radius: 5px;
}
</style>

<style>
/* 6.17 */
.cer-form .cer-select {
  width: 80px;
}
.cer-form .cer-select .el-input__inner {
  border: 1px solid #dcdfe6 !important;
  background: rgba(235, 236, 241, 0.43);
  border-radius: 4px 0 0 4px;
}
.cer-form .cer-select + .flex-bd .el-input__inner {
  border-radius: 0 4px 4px 0;
  border-left: 0;
}
.submit-con .el-tabs__header {
  width: 300px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
.submit-con .el-tabs__item {
  width: 50%;
  padding: 0;
}
.submit-con .el-tabs__nav {
  width: 100%;
}
.submit-con .el-tabs__item:hover {
  color: #fa6400;
}
.submit-con .el-tabs__item.is-active {
  color: #fa6400;
}
.submit-con .el-tabs__active-bar {
  background-color: #fa6400;
}
.cer-flex .el-input__inner {
  height: 36px;
}
.el-select-dropdown__item.selected {
  color: #fa6400;
  font-size: 500 !important;
}
</style>